import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, Container, Stack, Typography } from "@mui/material";
import AppUserSearchTable from "src/components/users/AppUserSearchTable";

export default function UserTabShortcutPage({
  actionLabel,
  description,
  tab,
  title,
}) {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>{title} | DreamTeam Admin</title>
      </Helmet>

      <Container maxWidth="xl">
        <Stack spacing={3}>
          <Stack spacing={1}>
            <Typography variant="h4">{title}</Typography>
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          </Stack>

          <Card>
            <CardContent>
              <Typography variant="subtitle2" color="text.secondary">
                Select a user to open the matching user detail tab.
              </Typography>
            </CardContent>
          </Card>

          <AppUserSearchTable
            actionLabel={actionLabel}
            onSelectUser={(row) =>
              navigate(`/dashboard/users/${row.id}?tab=${tab}`)
            }
          />
        </Stack>
      </Container>
    </>
  );
}

UserTabShortcutPage.propTypes = {
  actionLabel: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  tab: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
